export default __webpack_public_path__ + "static/media/cat.711814ad.PNG";